import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Services from '../pages/services/page';
import PMlaunchpad from '../pages/pm-launchpad/page';
import Portfolio from '../pages/portfolio/page';
import Shop from '../pages/shop/page';
import About from '../pages/about/page';
import Contact from '../pages/contact/page';
import BookConsultation from '../pages/book-consultation/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/pm-launchpad',
    element: <PMlaunchpad />,
  },
  {
    path: '/portfolio',
    element: <Portfolio />,
  },
  {
    path: '/shop',
    element: <Shop />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/book-consultation',
    element: <BookConsultation />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;